import { colors } from '@chegg-ui/theme'
import {
  CITATION_GENERATOR_BANNER,
  PLAGIARISM_CHECKER_BANNER,
  WRITING_ASSISTANT_BANNER,
} from '@chegg-wt/core-wa/constants/paraphraser'
import { AIStarIcon } from '../icons/AIStarIcon'
import { ParaphraseIcon } from '../icons'
import { BannerTextProps } from './components/types'
import {
  CopyBoyIcon,
  TargetIcon,
  CitationIcon,
  DownloadIcon,
  PaperIcon,
  PlagIcon,
  InfoIcon,
} from './icons'

export enum BANNER_TEXT_THEMES {
  DARK = 'dark',
  WHITE = 'white',
}

export const infoBannerTextList: BannerTextProps[] = [
  {
    subHeading: 'Writing Assistant',
    heading: 'Enhance your writing with instant feedback',
    textTheme: BANNER_TEXT_THEMES.WHITE,
    textContentHeadingFirst: 'Get free grammar checks',
    textContentHeadingSecond: 'Improve clarity and flow',
    textContentHeadingThird: 'Paraphrase',
    textContentFirst: 'We’ll help you catch spelling, grammar, and punctuation errors.',
    textContentSecond:
      'Our proofreader helps pinpoint unclear sections and shows you ways to enhance them.',
    textContentThird:
      'The paraphrasing tool will help you rephrase your writing until you love the way it sounds.',
    headingIcon: <AIStarIcon color={`${colors.white}`} />,
    textIconFirst: <CopyBoyIcon />,
    textIconSecond: <TargetIcon />,
    textIconThird: <ParaphraseIcon color={`${colors.white}`} width="24" height="24" />,
    testId: 'writing-assistant-text-content',
  },

  {
    subHeading: 'Citations Generator',
    heading: 'Create citations for your assignment',
    textTheme: BANNER_TEXT_THEMES.DARK,
    textContentHeadingFirst: 'Cite your sources',
    textContentHeadingSecond: 'Instantly export bibliographies',
    textContentFirst:
      'Generate citations for any assignment in thousands of styles, including MLA, APA, Chicago and Harvard.',
    textContentSecond:
      'Create the perfect bibliography or works cited page and export to your Google Drive or Microsoft Word.',
    headingIcon: <CitationIcon width="24" />,
    textIconFirst: <CitationIcon width="24" />,
    textIconSecond: <DownloadIcon />,
    testId: 'citation-generator-text-content',
  },

  {
    subHeading: 'Plagiarism Checker',
    heading: 'Check your writing against billions of sources',
    textTheme: BANNER_TEXT_THEMES.DARK,
    textContentHeadingFirst: 'Comprehensive plagiarism reports',
    textContentHeadingSecond: 'Scan any assignment',
    textContentFirst:
      'See what percentage of your paper is similar to the language from billions of other sources.',
    textContentSecond:
      'From lab reports to short essays, check any assignment for potential plagiarism.',
    headingIcon: <PlagIcon />,
    textIconFirst: <PaperIcon />,
    textIconSecond: <InfoIcon />,
    testId: 'plagiarism-checker-text-content',
  },
]

export const WRITING_ASSISTANT_TILE_ALT_TEXT = 'Woman refining writing assignment'
export const CREATE_CITATION_TILE_ALT_TEXT = 'Woman creating citation'
export const PLAGIARISM_TILE_ALT_TEXT = 'Man checking plagiarism'

export const infoBannerImages = [
  'writingAssistant',
  'citationGenerator',
  'plagiarismChecker',
]

export const getBannerContainerData = (bannerIndex: number) => {
  switch (bannerIndex) {
    case 0:
      return {
        color: `${colors.grey900}`,
        testId: WRITING_ASSISTANT_BANNER,
        isFlipped: false,
      }
    case 1:
      return {
        color: `${colors.orange050}`,
        testId: CITATION_GENERATOR_BANNER,
        isFlipped: true,
      }
    default:
      return {
        color: `${colors.violet100}`,
        testId: PLAGIARISM_CHECKER_BANNER,
        isFlipped: false,
      }
  }
}
